import React from 'react';

const Loading: React.FC = () => <></>;

export default Loading;
